// Padding
export const InlinePadding = {
	base: 8,
	md:   12,
	lg:   16,
} as const;

export const BlockPadding = {
	base: 6,
	md:   12,
	lg:   16,
} as const;

// Spacing
export const MainContentGap = {
	base: 16,
	md:   20,
	lg:   28,
} as const;

export const SectionGap = {
	base: 10,
	md:   12,
	lg:   16,
} as const;

export const SmallSectionGap = {
	base: 8,
	md:   10,
	lg:   12,
} as const;

export const GridGap = {
	base: 6,
	md:   8,
	lg:   10,
} as const;

export const TightSectionGap = 6;
export const TightGridGap = 8;

export const NoGap = 0;
export const SmallGap = 4;
export const MediumGap = 8;
export const LargeGap = 12;

export const DefaultStyle = {
	INLINE_PADDING:    InlinePadding,
	BLOCK_PADDING:     BlockPadding,
	CONTENT_GAP:       MainContentGap,
	SECTION_GAP:       SectionGap,
	SMALL_SECTION_GAP: SmallSectionGap,
	TIGHT_SECTION_GAP: TightSectionGap,
	GRID_GAP:          GridGap,
	TIGHT_GRID_GAP:    TightGridGap,
	NO_GAP:            NoGap,
	SMALL_GAP:         SmallGap,
	MEDIUM_GAP:        MediumGap,
	LARGE_GAP:         LargeGap,
} as const;